import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51c29d85")

_pushScopeId("data-v-51c29d85")
const _hoisted_1 = { class: "resource-picker" }
const _hoisted_2 = { class: "primary-color" }
const _hoisted_3 = { class: "button-with-label" }
const _hoisted_4 = { class: "modal-container resource-modal-container" }
const _hoisted_5 = { class: "toolbar-container" }
const _hoisted_6 = {
  key: 0,
  class: "modal-view-content file-picker-content"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("All")
const _hoisted_8 = {
  key: 0,
  class: "processing-hint"
}
const _hoisted_9 = {
  key: 1,
  class: "processing-hint"
}
const _hoisted_10 = {
  class: "button-with-label",
  style: {"margin-right":"6px"}
}
const _hoisted_11 = {
  type: "button",
  class: "custom-button button-dark file-button upload-resource-button file-button"
}
const _hoisted_12 = {
  class: "button-with-label",
  style: {"margin-left":"6px"}
}
const _hoisted_13 = {
  key: 2,
  class: "modal-view-content resource-info-container"
}
const _hoisted_14 = { class: "share-permission-container" }
const _hoisted_15 = { class: "toggle-wrapper" }
const _hoisted_16 = { class: "resource-label-container" }
const _hoisted_17 = { class: "resource-label-container" }
const _hoisted_18 = { class: "button-with-label" }
const _hoisted_19 = { class: "resource-item-name" }
const _hoisted_20 = { class: "button-with-label" }
const _hoisted_21 = {
  type: "button",
  class: "custom-button button-dark file-button upload-resource-button file-button"
}
const _hoisted_22 = { class: "modal-view-content resource-info-container" }
const _hoisted_23 = { class: "share-permission-container" }
const _hoisted_24 = { class: "toggle-wrapper" }
const _hoisted_25 = { class: "resource-label-container" }
const _hoisted_26 = { class: "resource-label-container" }
const _hoisted_27 = { class: "button-with-label" }
_popScopeId()

import {nextTick, onMounted, ref} from 'vue';
import {
    IonButton,
    IonButtons,
    IonContent,
    IonIcon,
    IonInput,
    IonItem,
    IonLabel,
    IonModal,
    IonTitle,
    IonToolbar,
    IonToggle,
    IonSegment
} from "@ionic/vue";
import {useStore} from "vuex";
import {computed, watch} from "vue";
import {
    addAppInstanceResource,
    createResourceFromLibraryAudio,
    deleteAppInstanceResource,
    getAppInstanceResources,
    updateAppInstanceResource
} from "@/services/AppInstanceService";
import {GET} from "@/services/HTTP";
import {addJourneyTabResource, getJourneyTabResources, removeJourneyTabResource} from "@/services/JourneyService";
import {close, closeOutline, filter, trashOutline} from 'ionicons/icons';
import {Resource, ResourceLink} from "@/models/ResourceModel";

/** Rows from GET /audio/instance/:id (same shape as AudioLibraryPicker). */
interface LibraryAudioFile {
    id: string;
    name: string;
    createdDate: string;
    sizeKb: number | null;
    processingMsg: string | null;
    instanceId: string | null;
    audioGroupId: string;
}
import {uuid4} from "@capacitor/core/dist/esm/util";
import {presentNativeAlert} from "@/services/Notify";
import { hasKnownMediaSizeKb, isLibraryAudioReady } from '@/utils/mediaSizeDisplay';
import {documentAttachOutline , musicalNotes , imageOutline, globeOutline,helpOutline,createOutline } from 'ionicons/icons';


export default _defineComponent({
  expose: [],
  props: {
    heading: {
        type: String,
        required: true
    },
    journeyId: {
        required: true
    },
    tabNum: {
        required: true
    }
},
  emits: ['update:heading', "update:resourceList"],
  setup(__props, { emit }) {

const props = __props



const acceptedMimeTypes = ["audio/mpeg", "application/pdf"]
const store = useStore();
const language = computed(() => store.getters['app/language']);
const appInstance = computed(() => store.getters['app/selectedAppInstanceId'] as string);
const allResources = ref<Resource[]>([]);
const libraryAudioFiles = ref<LibraryAudioFile[]>([]);

const audioLibraryUrlPrefix = 'x-audio-library:';

function linkedLibraryAudioIds(): Set<string> {
    return new Set(
        allResources.value
            .filter(r => r.url?.startsWith(audioLibraryUrlPrefix))
            .map(r => r.url!.substring(audioLibraryUrlPrefix.length))
    );
}
const tabResources = ref<ResourceLink[]>([]);
const modalState = ref<"closed" | "select" | "uploadConfirm" | "addLink">("closed");
const closeModalAfterEdit = ref(false);
const newResource = ref<Resource | null>(null);
const filterValue = ref<string>("all");
const modalOpen = computed({
    get: () => modalState.value !== "closed",
    set: (newValue: boolean) => {
        modalState.value = newValue ? "select" : "closed";
    }
});
const resourceType = computed(() => {
    if (newResource?.value?.mimeType == "text/x-uri") {
        return "url";
    } 
    return "file";
});
const urlRegex = /^(https?:\/\/)?([\w.-]+)?([\w-]+\.[a-z]{2,})(:\d+)?(\/[^\s]*)?$/i;

const isValidUrl = (url: string): boolean => {
    return urlRegex.test(url);
}
function ensureHttps(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
    }
    return url;
}

function resourceForUUID(resourceId: string) {
    return allResources.value.find(resource => resource.id === resourceId);
}

async function refreshResources(closeModal?: boolean) {
    const shouldClose = closeModal ?? true;
    console.log(`refreshResouces called with closeModal=${shouldClose}`);
    const instanceId = appInstance.value;
    if (instanceId) {
        allResources.value = await getAppInstanceResources(instanceId);
        try {
            libraryAudioFiles.value = (await GET(`/audio/instance/${instanceId}`, false)) ?? [];
        } catch {
            libraryAudioFiles.value = [];
        }
    } else {
        allResources.value = [];
        libraryAudioFiles.value = [];
    }
    tabResources.value = await getJourneyTabResources(props.journeyId, props.tabNum);
    if(shouldClose ) {
        modalOpen.value = false;
    }else{
        modalState.value = "select";
    }
}

async function assignResourceToTab(resource: Resource) {
    await addJourneyTabResource(props.journeyId, props.tabNum, resource);
    await refreshResources();
}

async function assignLibraryAudioToTab(file: LibraryAudioFile) {
    if (!isLibraryAudioReady(file) || !appInstance.value) {
        return;
    }
    const resource = await createResourceFromLibraryAudio(appInstance.value, file.id);
    await assignResourceToTab(resource);
}

async function removeResourceFromTab(resourceId: string) {
    await removeJourneyTabResource(props.journeyId, props.tabNum, resourceId);
    await refreshResources();
}

const getIcon = (mimeType: string) => {
      let iconStr = '';
      switch (mimeType) {
        case 'application/pdf':
          iconStr =  documentAttachOutline;
          break ;
        case 'audio/mp3':
        case 'audio/wav':
        case 'audio/mpeg':
          iconStr =  musicalNotes;
          break;
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
          iconStr = imageOutline;
          break ;
        case 'text/x-uri':
        case 'text/uri-list':
            iconStr = globeOutline;
            break;
        case 'video/mp4':
        case 'video/webm':
            iconStr =  'videocam-outline';
            break;
        default:
            iconStr =  'helpOutline';
      }
      return iconStr;
}

const checkVisiblity = (mimeType: string) => {
    if (filterValue.value === 'all' || filterValue.value === mimeType) {
        return true;
    }
    return false;
}

/** Library audio rows (not yet represented as a resource) for the current filter. */
function libraryAudioForPicker(): LibraryAudioFile[] {
    const linked = linkedLibraryAudioIds();
    return libraryAudioFiles.value.filter((file) => {
        if (linked.has(file.id)) {
            return false;
        }
        return checkVisiblity('audio/mpeg');
    });
}

async function uploadResource() {
    if (!newResource.value) {
        return;
    }
    if(newResource.value.mimeType === "text/x-uri" && newResource.value.url ){
        newResource.value.url = ensureHttps(newResource.value.url);
    }
    if(modalState.value !== "editResource"){
        await addAppInstanceResource(appInstance.value, newResource.value);
        await refreshResources();
        await assignResourceToTab(newResource.value);
        modalState.value = "closed";
    }else{
        newResource.value.appInstanceId = appInstance.value;
        await updateAppInstanceResource(appInstance.value, newResource.value);
        await refreshResources(closeModalAfterEdit.value);
    }
    newResource.value = null;
    
}

async function editResource(resourceId: string , closeAfterEdit: boolean)  {
    closeModalAfterEdit.value = closeAfterEdit;
    newResource.value = resourceForUUID(resourceId);
    if (newResource.value) {
        modalState.value = "editResource";
    }
}


async function deleteResource(resourceId: string) {
    await deleteAppInstanceResource(appInstance.value, resourceId);
    await refreshResources(false);

}

async function processSelectedResource(event: any) {
    const file = event.target.files[0];
    if (!file) {
        return;
    }else if (file.size > 7 * 1024 * 1024){
        modalState.value = "closed";
        await presentNativeAlert({
            backdropDismiss: false,
            cssClass: 'custom-alert',
            message: language.value.validation.resourceFileSizeError,
            buttons: [language.value.okay],
        });
        return;
    }
    const reader = new FileReader();
    reader.onload = async (e) => {
        const data = e.target?.result;
        if(modalState.value === "editResource"){
            newResource.value.resourceData = data as string;
            newResource.value.name = file.name;
        }else{ 
            newResource.value = {
                id: uuid4(),
                name: file.name,
                resourceData: data as string,
                mimeType: file.type,
                appInstanceId: appInstance.value,
                shareable: false,
                resourceLabel: null
            };
            modalState.value = "uploadConfirm";
        }
    }
    if (!acceptedMimeTypes.includes(file.type)) {
        modalState.value = "closed";
        await presentNativeAlert({
            backdropDismiss: false,
            cssClass: 'custom-alert',
            message: language.value.validation.resourceFileTypeError,
            buttons: [language.value.okay],
        });
        return;
    }
    reader.readAsDataURL(file);
    reader.onerror = async () => {
        modalState.value = "closed";
        await presentNativeAlert({
            backdropDismiss: false,
            cssClass: 'custom-alert',
            message: language.value.errors.savingFiles,
            buttons: [language.value.okay],
        });
    }
}

async function processUrlResource() {
    newResource.value = {
            id: uuid4(),
            name: "",
            resourceData: "",
            mimeType: "text/x-uri",
            appInstanceId: appInstance.value,
            shareable: false,
            resourceLabel: null
        };
    modalState.value = "addLink";
}

function nonAttachedResourceList() {
    return allResources.value.filter(resource => !tabResources.value.find(tabResource => tabResource.resourceId === resource.id));
}


onMounted(async () => {
    await refreshResources();
})

watch(
    () => [props.journeyId, props.tabNum],
    async () => {
        await refreshResources();
    }
);

watch(
    () => appInstance.value,
    async () => {
        await refreshResources();
    }
);

function passLabelUp(newValue: any) {
    emit('update:heading', newValue);
}

return /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_unref(IonItem), null, {
      default: _withId(() => [
        _createVNode(_unref(IonLabel), { position: "stacked" }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_unref(language).resourceHeading), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonInput), {
          autocomplete: "off",
          placeholder: _unref(language).resourceHeadingSample,
          modelValue: __props.heading,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(heading) ? heading.value = $event : null)),
          onIonChange: _cache[2] || (_cache[2] = ($event: any) => (passLabelUp($event.detail.value)))
        }, null, 8, ["placeholder", "modelValue"])
      ]),
      _: 1
    }),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(tabResources.value, (resourceLink) => {
      return (_openBlock(), _createBlock(_unref(IonItem), {
        lines: "full",
        mode: "md",
        key: resourceLink.id
      }, {
        default: _withId(() => [
          _createVNode(_unref(IonIcon), {
            icon: getIcon(resourceForUUID(resourceLink.resourceId).mimeType),
            class: "resource-icon"
          }, null, 8, ["icon"]),
          _createVNode(_unref(IonLabel), { class: "vertical-padding" }, {
            default: _withId(() => [
              _createVNode("p", _hoisted_2, _toDisplayString(resourceForUUID(resourceLink.resourceId).resourceLabel || resourceForUUID(resourceLink.resourceId).name), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(IonButtons), { slot: "end" }, {
            default: _withId(() => [
              _createVNode(_unref(IonButton), {
                onClick: ($event: any) => (removeResourceFromTab(resourceLink.resourceId))
              }, {
                default: _withId(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(close),
                    size: "t"
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_unref(IonButton), {
                onClick: ($event: any) => (editResource(resourceLink.resourceId , true))
              }, {
                default: _withId(() => [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(createOutline),
                    size: "t"
                  }, null, 8, ["icon"])
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_unref(IonItem), {
      lines: "none",
      mode: "md"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode("button", {
            type: "button",
            class: "custom-button button-dark file-button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (modalOpen.value = true))
          }, [
            _createVNode("span", null, _toDisplayString(_unref(language).attachResource), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonModal), {
      "is-open": _unref(modalOpen),
      backdropDismiss: "false",
      mode: "md",
      "css-class": "custom-modal add-resource-modal",
      onIonModalDidDismiss: _cache[12] || (_cache[12] = ($event: any) => (modalOpen.value = false))
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode(_unref(IonContent), { class: "ion-no-padding resource-content" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_unref(IonToolbar), null, {
                  default: _withId(() => [
                    (modalState.value == 'select')
                      ? (_openBlock(), _createBlock(_unref(IonTitle), {
                          key: 0,
                          class: "md title-default hydrated title-no-padding"
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_unref(language).previousResources), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(IonButtons), { slot: "end" }, {
                      default: _withId(() => [
                        _createVNode(_unref(IonButton), {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (modalOpen.value = false))
                        }, {
                          default: _withId(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              (modalState.value != 'editResource')
                ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
                    default: _withId(() => [
                      (modalState.value == 'select')
                        ? (_openBlock(), _createBlock("div", _hoisted_6, [
                            _createVNode(_unref(IonToolbar), { class: "resource-filter-toolbar" }, {
                              default: _withId(() => [
                                _createVNode(_unref(IonSegment), {
                                  modelValue: filterValue.value,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (filterValue.value = $event)),
                                  mode: "ios",
                                  style: {"margin":"0px 12px"},
                                  value: "all"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_segment_button, {
                                      value: "all",
                                      checked: ""
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_unref(IonLabel), { class: "resource-filter-label" }, {
                                          default: _withId(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      class: "resource-filter-label",
                                      value: "audio/mpeg"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withId(() => [
                                            _createVNode(_unref(IonIcon), {
                                              class: "resource-filter-icon",
                                              icon: _unref(musicalNotes)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      class: "resource-filter-label",
                                      value: "application/pdf"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withId(() => [
                                            _createVNode(_unref(IonIcon), {
                                              class: "resource-filter-icon",
                                              icon: _unref(documentAttachOutline)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_segment_button, {
                                      class: "resource-filter-label",
                                      value: "text/x-uri"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withId(() => [
                                            _createVNode(_unref(IonIcon), {
                                              class: "resource-filter-icon",
                                              icon: _unref(globeOutline)
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(libraryAudioForPicker(), (file) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                lines: "full",
                                mode: "md",
                                key: `library-audio-${file.id}`,
                                class: { 'audio-library-processing': !_unref(hasKnownMediaSizeKb)(file.sizeKb) && !file.processingMsg }
                              }, {
                                default: _withId(() => [
                                  _createVNode(_unref(IonIcon), {
                                    icon: _unref(musicalNotes),
                                    class: "resource-icon"
                                  }, null, 8, ["icon"]),
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withId(() => [
                                      _createVNode("span", {
                                        class: ["resource-item-name", { 'resource-item-name--disabled': !_unref(isLibraryAudioReady)(file) }],
                                        onClick: ($event: any) => (_unref(isLibraryAudioReady)(file) ? assignLibraryAudioToTab(file) : null)
                                      }, [
                                        _createTextVNode(_toDisplayString(file.name) + " ", 1),
                                        (file.processingMsg)
                                          ? (_openBlock(), _createBlock("span", _hoisted_8, " — " + _toDisplayString(file.processingMsg), 1))
                                          : (!_unref(hasKnownMediaSizeKb)(file.sizeKb))
                                            ? (_openBlock(), _createBlock("span", _hoisted_9, " — " + _toDisplayString(_unref(language).processing || 'Processing…'), 1))
                                            : _createCommentVNode("", true)
                                      ], 10, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(nonAttachedResourceList(), (resource) => {
                              return _withDirectives((_openBlock(), _createBlock(_unref(IonItem), {
                                lines: "full",
                                mode: "md",
                                key: `resource-${resource.id}`
                              }, {
                                default: _withId(() => [
                                  _createVNode(_unref(IonIcon), {
                                    icon: getIcon(resource.mimeType || ''),
                                    class: "resource-icon"
                                  }, null, 8, ["icon"]),
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withId(() => [
                                      _createVNode("span", {
                                        class: "resource-item-name",
                                        onClick: ($event: any) => (assignResourceToTab(resource))
                                      }, _toDisplayString(resource.resourceLabel || resource.name), 9, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonButtons), { slot: "end" }, {
                                    default: _withId(() => [
                                      (resource.inUseCnt == 0)
                                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                                            key: 0,
                                            onClick: ($event: any) => (deleteResource(resource.id))
                                          }, {
                                            default: _withId(() => [
                                              _createVNode(_unref(IonIcon), { icon: _unref(trashOutline) }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_unref(IonButton), {
                                        onClick: ($event: any) => (editResource(resource.id , false))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_unref(IonIcon), {
                                            icon: _unref(createOutline),
                                            size: "t"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1536)), [
                                [_vShow, checkVisiblity(resource.mimeType || '')]
                              ])
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (modalState.value == 'select')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 1,
                            lines: "none",
                            mode: "md",
                            class: "upload-resource-block"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_10, [
                                _createVNode("button", _hoisted_11, [
                                  _createVNode("span", null, _toDisplayString(_unref(language).uploadResources), 1),
                                  _createVNode("input", {
                                    type: "file",
                                    onChange: processSelectedResource,
                                    accept: "audio/mpeg, application/pdf"
                                  }, null, 32)
                                ])
                              ]),
                              _createVNode("div", _hoisted_12, [
                                _createVNode("button", {
                                  type: "button",
                                  class: "custom-button button-dark file-button upload-resource-button file-button",
                                  onClick: processUrlResource
                                }, [
                                  _createVNode("span", null, _toDisplayString(_unref(language).addUrl), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (modalState.value == 'uploadConfirm' || modalState.value == 'addLink')
                        ? (_openBlock(), _createBlock("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, [
                              _createVNode("h5", null, _toDisplayString(_unref(language).allowResourceSharing), 1),
                              _createVNode("div", _hoisted_15, [
                                _createVNode(_unref(IonLabel), {
                                  color: "primary",
                                  style: {"white-space":"normal"}
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_unref(language).no), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonToggle), {
                                  mode: "md",
                                  style: {"margin-right":"15px","margin-left":"15px"},
                                  modelValue: newResource.value.shareable,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (newResource.value.shareable = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_unref(IonLabel), {
                                  color: "primary",
                                  style: {"white-space":"normal"}
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(_unref(language).yes), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_16, [
                              _createVNode(_unref(IonInput), {
                                fill: "outline",
                                class: [{'invalid-url': !isValidUrl(newResource.value.url)}, "text-centered"],
                                autocomplete: "off",
                                placeholder: _unref(language).enterUrl,
                                modelValue: newResource.value.url,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (newResource.value.url = $event))
                              }, null, 8, ["class", "placeholder", "modelValue"]),
                              (!isValidUrl(newResource.value.url))
                                ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                    key: 0,
                                    class: "invalid-url-message"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode("**" + _toDisplayString(_unref(language).validation.invalidUrl) + "**", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, modalState.value == 'addLink']
                            ]),
                            _createVNode("div", _hoisted_17, [
                              _createVNode("h5", null, _toDisplayString(_unref(language).resourceLabelMessage), 1),
                              _createVNode(_unref(IonInput), {
                                fill: "outline",
                                class: "text-centered",
                                autocomplete: "off",
                                placeholder: newResource.value.name.replace(/\.[^/.]+$/, ''),
                                modelValue: newResource.value.resourceLabel,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (newResource.value.resourceLabel = $event))
                              }, null, 8, ["placeholder", "modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (modalState.value == 'uploadConfirm' || modalState.value == 'addLink')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 3,
                            lines: "none",
                            mode: "md",
                            class: "upload-resource-block"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_18, [
                                _createVNode("button", {
                                  type: "button",
                                  class: "custom-button button-dark file-button upload-resource-button file-button",
                                  onClick: uploadResource
                                }, [
                                  _createVNode("span", null, _toDisplayString(_unref(language).finishAndSave), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(IonContent), { key: 1 }, {
                    default: _withId(() => [
                      (newResource.value?.mimeType != 'text/x-uri')
                        ? (_openBlock(), _createBlock(_unref(IonItem), {
                            key: 0,
                            lines: "none",
                            mode: "md",
                            class: "file-based-resource"
                          }, {
                            default: _withId(() => [
                              _createVNode(_unref(IonIcon), {
                                icon: getIcon(newResource.value?.mimeType || ''),
                                class: "resource-icon"
                              }, null, 8, ["icon"]),
                              _createVNode(_unref(IonLabel), null, {
                                default: _withId(() => [
                                  _createVNode("span", _hoisted_19, _toDisplayString(newResource.value?.name), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(IonButtons), { slot: "end" }, {
                                default: _withId(() => [
                                  _createVNode("div", _hoisted_20, [
                                    _createVNode("button", _hoisted_21, [
                                      _createVNode("span", null, _toDisplayString(_unref(language).uploadResources), 1),
                                      _createVNode("input", {
                                        type: "file",
                                        onChange: processSelectedResource,
                                        accept: "audio/mpeg, application/pdf"
                                      }, null, 32)
                                    ])
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("div", _hoisted_23, [
                          _createVNode("h5", null, _toDisplayString(_unref(language).allowResourceSharing), 1),
                          _createVNode("div", _hoisted_24, [
                            _createVNode(_unref(IonLabel), {
                              color: "primary",
                              style: {"white-space":"normal"}
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_unref(language).no), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonToggle), {
                              mode: "md",
                              style: {"margin-right":"15px","margin-left":"15px"},
                              modelValue: newResource.value.shareable,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (newResource.value.shareable = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(IonLabel), {
                              color: "primary",
                              style: {"white-space":"normal"}
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_unref(language).yes), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_25, [
                          _createVNode(_unref(IonInput), {
                            fill: "outline",
                            class: [{'invalid-url': !isValidUrl(newResource.value?.url || '')}, "text-centered"],
                            autocomplete: "off",
                            placeholder: _unref(language).enterUrl,
                            modelValue: newResource.value.url,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (newResource.value.url = $event))
                          }, null, 8, ["class", "placeholder", "modelValue"]),
                          (!isValidUrl(newResource.value?.url || ''))
                            ? (_openBlock(), _createBlock(_unref(IonLabel), {
                                key: 0,
                                class: "invalid-url-message"
                              }, {
                                default: _withId(() => [
                                  _createTextVNode("**" + _toDisplayString(_unref(language).validation.invalidUrl) + "**", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 512), [
                          [_vShow, newResource.value?.mimeType == 'text/x-uri']
                        ]),
                        _createVNode("div", _hoisted_26, [
                          _createVNode("h5", null, _toDisplayString(_unref(language).resourceLabelMessage), 1),
                          _createVNode(_unref(IonInput), {
                            fill: "outline",
                            class: "text-centered",
                            autocomplete: "off",
                            modelValue: newResource.value.resourceLabel,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (newResource.value.resourceLabel = $event)),
                            placeholder: newResource.value.name.replace(/\.[^/.]+$/, '')
                          }, null, 8, ["modelValue", "placeholder"])
                        ])
                      ]),
                      _createVNode(_unref(IonItem), null, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_27, [
                            _createVNode("button", {
                              type: "button",
                              class: "custom-button button-dark file-button upload-resource-button file-button",
                              onClick: uploadResource
                            }, [
                              _createVNode("span", null, _toDisplayString(_unref(language).finishAndSave), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
})
}

})